import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, finalize, map, timeout, tap } from 'rxjs/operators';
import {environment} from "@env/environment";
import { InactivityService } from '../auth/inactivity.service';

const APP_XHR_TIMEOUT = 600000;

@Injectable()
export class DefaultInterceptor implements HttpInterceptor {
  private inactivityService: InactivityService | null = null;

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Notificar actividad al servicio de inactividad (lazy loading para evitar dependencia circular)
    if (!this.inactivityService) {
      try {
        this.inactivityService = this.injector.get(InactivityService);
      } catch (e) {
        // El servicio aún no está disponible
      }
    }

    // Notificar que hubo una petición HTTP (indica actividad del usuario)
    if (this.inactivityService && !req.url.includes('assets') && !req.url.includes('mock')) {
      this.inactivityService.notifyActivity();
    }

    return next.handle(this.performRequest(req)).pipe(
      timeout(APP_XHR_TIMEOUT),
      map(res => this.handleSuccessfulResponse(res)),
      catchError(err => this.handleErrorResponse(err)),
      finalize(this.handleRequestCompleted.bind(this))
    );
  }

  private getAdditionalHeaders(headers?: HttpHeaders): {
    [name: string]: string;
  } {
    const res: { [name: string]: string } = {};
    return res;
  }

  private performRequest(req: HttpRequest<any>): HttpRequest<any> {
    let headers: HttpHeaders = req.headers;

    // Prefijo de servidor unificado
    let url = req.url;
    const isExternalUrl = url.startsWith('https://');
    // Las URLs de nómina (/nomina/), SST (/sst/) y contratación local (/contratacion/) se dejan relativas para que pasen por el proxy
    if (!isExternalUrl && !url.startsWith('http://') && !url.includes('assets') && !url.includes('mock') && !url.startsWith('/nomina/') && !url.startsWith('/sst/') && !url.startsWith('/contratacion/')) {
      const baseUrl = environment.baseUrlAPi;
      url = baseUrl + (baseUrl.endsWith('/') && url.startsWith('/') ? url.substring(1) : url);
    }
    return req.clone({ url, setHeaders: this.getAdditionalHeaders(headers) });
}


  private handleSuccessfulResponse(event: any): HttpResponse<any> {
    if (event instanceof HttpResponse) {
      // Optional chaining obligatorio: en un 204 el body llega null y
      // `null.response` reventaba con TypeError DESPUÉS de que el backend ya
      // había borrado — el usuario veía error sobre una operación exitosa.
      // Con undefined, clone() conserva el body original (así ya se comportaba
      // con las respuestas normales, que tampoco traen `.response`).
      event = event.clone({ body: event.body?.response });
    }
    return event;
  }

  private handleErrorResponse(errorResponse: any): Observable<HttpEvent<any>> {
    if (errorResponse instanceof TimeoutError) {
      return throwError(() => 'Timeout Exception');
    }
    switch (errorResponse.status) {
      case 401: // Unauthorized
        break;
      case 404:
      case 500:
        return throwError(() => errorResponse);
      case 503: // Internal Server Error
        break;
      default: // Other Error
    }


    return throwError(() => errorResponse);
  }

  private handleRequestCompleted(): void {
  }
}
